import { Button } from "@/components/clickable";
import { Heading } from "@/components/heading";
import { HStack, VStack } from "@/components/layout";
import { Text } from "@/components/text";

export default function WelcomeView() {
  return (
    <HStack className="h-svh w-full items-center justify-center p-6 lg:bg-zinc-100">
      <VStack className="border-cp-greyscale-400 w-full max-w-screen-sm items-center gap-4 rounded-2xl border p-10 shadow-lg">
        <Heading>Congratulations!</Heading>
        <Text className="text-center text-lg">Your account is ready!</Text>
        <Button href="/">Access Platform</Button>
      </VStack>
    </HStack>
  );
}
